import session from 'lib/session';

interface GainsightFunction {
  queue: any[];
  p: string; // API_Key
  customOption?: string;
  (...args: any[]): void;
}

declare global {
  interface Window {
    aptrinsic: GainsightFunction;
  }
}

function initTracking(
  windowObject: Window,
  documentObject: Document,
  a: string, // Script_URL
  e: string, //API_Key
  customOption?: string
): Promise<void> {
  return new Promise((resolve, reject) => {
    const gainsightProperty = 'aptrinsic';

    windowObject[gainsightProperty] =
      windowObject[gainsightProperty] ||
      function (...args: any[]) {
        (windowObject[gainsightProperty].queue =
          windowObject[gainsightProperty].queue || []).push(args);
      };

    windowObject[gainsightProperty].p = e;
    windowObject[gainsightProperty].customOption = customOption;

    const scriptElement = documentObject.createElement('script');
    scriptElement.async = true;
    scriptElement.src = `${a}?a=${e}`;

    scriptElement.onload = () => {
      console.log('Tracking script loaded successfully.');
      resolve();
    };

    scriptElement.onerror = (error) => {
      console.error('Failed to load the Tracking script.', error);
      reject(error);
    };

    documentObject.head.appendChild(scriptElement);
  });
}

export default initTracking;

const getTrackingEvent = (): GainsightFunction => window.aptrinsic;

export function trackIdentity(details: Record<string, any>): void {
  const tracking = getTrackingEvent();

  const userId = session.userId;

  if (tracking && userId) {
    tracking('identify', {
      id: userId,
      ...details,
    });
  } else {
    console.error('Tracking is not initialized yet');
  }
}
